import React, { Component, createRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Navigation from "../screens/Navigation.jsx";
import Headroom from "react-headroom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios"
import { Modal, Row } from "react-bootstrap";
import Markdownkatexnew from "./Markdown.js";
import Select, { components } from 'react-select';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/es';

import Socket from "../screens/Chat.jsx";
import { isAuth } from "../helpers/auth.js";
import { MdDownload } from "react-icons/md";
import { BiDownload } from "react-icons/bi";
import { FaDownload } from "react-icons/fa";

const techOptions = [
	{ value: 'direccion', label: 'Direccion' },
	{ value: 'academico', label: 'Académico' },
	{ value: 'administracion', label: 'Administración' },
	{ value: 'subdireccion', label: 'Sub dirección' },
	{ value: 'jefeeducacion', label: 'Jefe de educacion' },
	{ value: 'jefeartista', label: 'Jefe de artista profesional' }
];


export default class CreateNote extends Component {
	state = {
		showModal: false, title: "", detail: "", option: '', dependence: "direccion", name: '', size: '', type: '', file: "", i: '', ip: '', j: '', k: '', remiter: 	'', id: "", dni: "", tramites: "",
		submit: "Crear",
		savedtramite: [],
		editing: false
	};

	// [{
	// 	"dni": "76987341",
	// 	"nombres": "VIRMA CHARMELY",
	// 	"apellidomaterno": "ARAUJO",
	// 	"apellidopaterno": "FLORES",
	// }]
	open = () => this.setState({ showModal: true });
	close = () => this.setState({ showModal: false });

	async componentWillUnmount() {

	}

	async componentDidMount() {
		fetch('https://ipapi.co/json/')
			.then((res) => res.json())
			.then((data) => {
				console.log(data, "wwwwwwww")
				this.setState({
					ip: data,
				});
			})
			.catch((err) => console.error("Error fetching IP location:", err))

		await this.getTramites()
		this.getstorages()
	}

	getstorages = async () => {
		const wwwww = localStorage.getItem('tramite');
		this.setState({ savedtramite: JSON.parse(wwwww) })
		console.log(this.state.savedtramite);

	}

	getTramites = async () => {

		await axios.get(`${process.env.REACT_APP_API_URL}/tramites`)
			.then((res) => {
				console.log(res.data, "www")
				this.setState({ tramites: res.data })
				// this.setState({ editing: false })
			})
			.catch((err) => {
				toast.error(err);
			})
	};


	getRemiter = async () => {
		this.setState({ editing: true })

		await axios.post(`${process.env.REACT_APP_API_URL}/users/userDni`, { dni: this.state.dni })
			.then((res) => {
				console.log(res.data.data, "www")
				this.setState({ remiter: res.data.data })
				this.setState({ editing: false })
			})
			.catch((err) => {
				toast.error(err);
			})
	};

	getReduce = async () => {
		this.setState({ editing: true })

		await axios.post(`${process.env.REACT_APP_API_URL}/users/userReduce`, { dni: this.state.dni })
			.then((res) => {
				console.log(res.data.data, "www")
				this.setState({ remiter: res.data.data })
				this.setState({ editing: false })
			})
			.catch((err) => {
				toast.error(err);
			})
	};

	sendSurvey = async () => {

		this.setState({ editing: true })

		const data = new FormData()
		data.append("title", this.state.title)
		data.append("dependence", this.state.dependence)
		data.append("proveido", [])
		data.append("archivo", this.state.file)
		data.append("dni", this.state.remiter.dni)
		data.append("nombres", this.state.remiter.nombres)
		data.append("apellidomaterno", this.state.remiter.apellidoMaterno)
		data.append("apellidopaterno", this.state.remiter.apellidoPaterno)
		data.append("asunto", this.state.title)
		data.append("detail", this.state.detail)
		console.log(data)

		await axios.post(`${process.env.REACT_APP_API_URL}/tramites/`, data)
			.then((www) => {
				this.getTramites()
				console.log(www.data.saved)
				this.setState({ editing: false })

				let myArray = JSON.parse(localStorage.getItem('tramite')) || [];
				let newItem = www.data.saved;
				myArray.push(newItem);
				localStorage.setItem('tramite', JSON.stringify(myArray));
				this.getstorages()
			})
			.catch((err) => {
				toast.error(err);
			})
	};


	onInputChange = e => {
		console.log(e.target.name, e.target.value)
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	fileSelectHandler = (file) => {
		console.log(file);
		this.setState({
			file: file[0],
			name: file[0].name,
			size: file[0].size,
			type: file[0].type,
		})
		const array = ['application/pdf', 'pdf', 'jpg']
		if (file[0].size < 105048576 && array.includes(file[0].type)) {
			console.log(file[0])
			const reader = new FileReader();
			// reader.onload = e => setFormData({ ...formData, photoSelected: reader.result, files: file, namefile: file[0].type });
			reader.readAsDataURL(file[0]);
		} else {
			toast.dark(
				"Solo se acepta archivos no mayor a 1MB en formatos pdf, jpeg, jpg y png "
			);
		}
	}

	deleteSurvey = async (id, i) => {
		const response = window.confirm("Deseas eliminar este item?");
		if (response) {

			let myData = JSON.parse(localStorage.getItem('tramite'));
			myData.splice(i, 1);
			localStorage.setItem('tramite', JSON.stringify(myData));

			await axios.delete(`${process.env.REACT_APP_API_URL}/tramites/${id}`, { dni: this.state.dni })
				.then((res) => {
					// console.log(res.data.data, "www")
					this.getstorages()
					this.getTramites()
				})
				.catch((err) => {
					toast.error(err);
				})

		}
	}


	handleChange = (e) => {
		console.log(e.value)
		this.setState({
			dependence: e.value,
		})
	};

	fileInputRef = createRef();
	fileInput = () => {
		if (this.fileInputRef.current) {
			this.fileInputRef.current.click();
			// this.inputRef.current.focus();
		}
	};


	render() {
		const { selectedOption } = this.state;

		return (
			<>
				<ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />
				<Headroom>
					<Navigation />
				</Headroom>

				<Modal show={this.state.showModal} onHide={() => { this.close(); }} animation={false}>
					<div className="modal-header font-weight-bold h5"> {this.state.submit} </div>
					<div className="modal-body">
						<div className="mb-3">
							<label htmlFor="www" className="form-label">Título</label>
							<input type="text" id="www" className="form-control my-1" placeholder="Título" onChange={this.onInputChange} name="title" value={this.state.title} />
						</div>

						<div className="mb-3">
							<label htmlFor="wwwww" className="form-label">Detalle (Escriba texto en formato Markdown [<a href="https://www.markdownguide.org/basic-syntax/" target="_blank">Tutorial!</a>])</label>
							<textarea type="text" id="wwwww" className="form-control scroll" placeholder="Contenido" rows="9" name="detail" onChange={this.onInputChange} value={this.state.detail} required ></textarea>
							<Markdownkatexnew>
								{this.state.detail}
							</Markdownkatexnew>
						</div>
					</div>
					<div className="modal-footer d-flex right-content-center">
						{this.state.option === '1' ? <button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.CreateTheme() }}> CrearTheme </button> : ""}
						<button type="button" className="btn btn-info" data-dismiss="modal" aria-label="Close" onClick={() => { this.close() }}> Close </button>
					</div>
				</Modal >


				<div className="container p-1 my-3">

					{isAuth().rol === '1' ? <button className="btn btn-primary my-3 form-control" onClick={this.getReduce} disabled={this.state.editing}>
						Verificar
					</button> : ''}
					<br />
					<div className="input-group">
						<input type="text" id="www" className="form-control" placeholder="DNI" disabled={this.state.editing} name="dni" onChange={this.onInputChange} value={this.state.dni} />
						<button className="btn btn-primary form-control" onClick={this.getRemiter} disabled={this.state.editing}>
							Verificar para enviar
						</button>
					</div>

					{this.state.remiter != '' ?
						<>						<div className="row justify-content-center align-items-center" style={{ padding: '.8em' }}>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">DNI: {this.state.remiter.dni}</label>
							</div>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">Nombres: {this.state.remiter.nombres}</label>
							</div>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">Apellido paterno: {this.state.remiter.apellidoPaterno}</label>
							</div>
							<div className="col-md-3 text-center" style={{ padding: '.1em' }}>
								<label htmlFor="www" className="form-label">Apellido materno: {this.state.remiter.apellidoMaterno}</label>
							</div>
							<input type="file" className="form-control d-none" onChange={(e) => { this.fileSelectHandler(e.target.files); }} ref={this.fileInputRef}>
							</input>
						</div>

							<div className="mb-3">
								<div>
									<label htmlFor="wwwww" className="form-label mt-3">Dependencia a enviar</label>
									<Select className="" value={this.state.dependence} onChange={this.handleChange} options={techOptions} placeholder="Seleccione dependencia" />
								</div>
								<label htmlFor="wwwww" className="form-label mt-3">Asunto</label>
								<input type="text" id="www" className="form-control" placeholder="Asunto" name="title" onChange={this.onInputChange} value={this.state.title} />

								<label htmlFor="wwwww" className="form-label mt-3">Detalles</label>
								<CKEditor className="form-control" editor={ClassicEditor} config={{
									language: 'es', placeholder: "Descripción de tramite",
									toolbar: ["math", "|", "undo", "redo", "|", "bold", "italic", "link", "bulletedList", "numberedList", "|", "indent", "outdent", "|", "blockQuote", "insertTable", "mediaEmbed", "heading"]
								}} data={this.state.detail} onChange={(event, editor) => {
									this.setState({ detail: editor.getData() })
									//wwWw(editor.getData())
								}} onReady={editor => {
									// console.log('Editor is ready to use!', editor)
								}}
									name="detail"
								/>
							</div>


							<button className="btn btn-warning w-100" onClick={this.fileInput}>Cargar archivo</button>
							<br />
							{this.state.name ?
								<div className=" text-center w-100">Nombre: {this.state.name} Tamaño: {this.state.size} Tipo: {this.state.type}
									<br />
									{/* <button className="btn btn-info text-center w-100" onClick={() => { this.open(); this.setState({ option: "1w", title: 'note.title' }) }} >
										Enviar tramite
									</button> */}
									<button className="btn btn-info text-center w-100" onClick={() => { this.sendSurvey() }} disabled={this.state.editing}>
										Enviar tramite
									</button>
								</div>
								: ''}
						</> : ''
					}


					<div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
						{
							this.state.savedtramite && this.state.savedtramite.length >= 1 ? this.state.savedtramite.map((number, i) =>
								<div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
									<>
										<div className="p-1 bg-light rounded">
											<div className="h5">
												{number.title}
											</div>
											<div className="">
												{number.dni} {number.nombres} {number.apellidopaterno} {number.apellidomaterno}
											</div>
											<Markdownkatexnew>
												{number.detail}
											</Markdownkatexnew>
											{number.file ? <a className="btn" target="_blank" href={`${process.env.REACT_APP_URL}/tramite/${number.file}`} >
												<FaDownload style={{ color: '#92bee0ff', fontSize: '34px' }} />
											</a> : ''}
										</div>
										<button className="btn btn-info text-center w-100" onClick={() => { this.deleteSurvey(number._id, i) }} >
											Borrar tramite
										</button>
									</>
								</div>
							) : ''}
					</div>

					{/* < Socket /> */}


					<div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
						{
							this.state.tramites ? this.state.tramites.map((number, i) =>
								<div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
									{isAuth().rol === '1' ?
										<>
											<div className="p-1 bg-light rounded">
												<div className="h5">
													{number.title}
												</div>
												<div className="">
													{number.dni} {number.nombres} {number.apellidopaterno} {number.apellidomaterno}
												</div>
												<Markdownkatexnew>
													{number.detail}
												</Markdownkatexnew>
												{number.file ? <a className="btn" target="_blank" href={`${process.env.REACT_APP_URL}/tramite/${number.file}`} >
													<FaDownload style={{ color: '#92bee0ff', fontSize: '34px' }} />
												</a> : ''}
											</div>
											<button className="btn btn-info text-center w-100" onClick={() => { this.deleteSurvey(number._id) }} >
												Borrar tramite
											</button>
										</>
										: ''}
								</div>
							) : ''}
					</div>
				</div>
			</>
		);
	}
}
